import { ICallAndSetData } from "@/services/api-service/interface";
import { getSetApiData } from "@/services/api-service/get-set-api-data";
import { EHttpMethod } from "@/services/api-service/enums";
const GET_ALL_PAYMENT_TERMS_URL = "/v1/crm-service/payment-terms/get-all";
const ADD_PAYMENT_TERM_URL = "/v1/crm-service/payment-terms/add";
const UPDATE_PAYMENT_TERM_URL = "/v1/crm-service/payment-terms/update";
const DELETE_PAYMENT_TERM_URL = "/v1/crm-service/payment-terms/delete";

export type PaymentTermItem = {
  id: string;
  code: number;
  name: string;
  cardType: number;
};

const getAllPaymentTermsApi: ICallAndSetData = async (callApi, setState, data) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.GET,
    GET_ALL_PAYMENT_TERMS_URL,
    setState,
    data,
  );
};

const addPaymentTermApi: ICallAndSetData = async (
  callApi,
  setState,
  data: { code: number; name: string; cardType: number },
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    ADD_PAYMENT_TERM_URL,
    setState,
    data,
  );
};

const updatePaymentTermApi: ICallAndSetData = async (
  callApi,
  setState,
  data: { id: string; code: number; name: string },
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.POST,
    UPDATE_PAYMENT_TERM_URL,
    setState,
    data,
  );
};

const deletePaymentTermApi: ICallAndSetData = async (
  callApi,
  setState,
  data: { id: string },
) => {
  return await getSetApiData(
    callApi,
    EHttpMethod.DELETE,
    DELETE_PAYMENT_TERM_URL,
    setState,
    data,
  );
};

export {
  getAllPaymentTermsApi,
  addPaymentTermApi,
  updatePaymentTermApi,
  deletePaymentTermApi,
};
